<template lang="html">
  <div id="wizard" class="checkoutwizard">
    <Header 
      :step="step"
      :firstStepCompleted="firstStepCompleted"
      @navigate="changeStep($event)"
    />
    
    <transition-group name="fade" mode="out-in">
      <Step1
        v-show="step === 1"
        @openModal="openModal($event), proceedError = false, proceedErrorMsg = ''"
        @isViewingPartners="isViewingPartners($event)"
        @select="selectedPartner = $event, proceedError = false, proceedErrorMsg = ''"
        @hasSelected="firstStepCompleted = true, proceedError = false, proceedErrorMsg = ''"
        :preSelected="selectedPartner"
        :partners="formattedPartners"
        key="1"
      />
      <Step2 
        v-show="step === 2"
        :pageType="pageType"
        @persoonsgegevens="persoonsgegevens = $event"
        @factuurgegevens="factuurgegevens = $event"
        @overig="overig = $event"
        @ready="secondStepCompleted = $event"
        ref="step2"
        key="2"
      />
    </transition-group>

    <Footer 
      v-if="showNextStepButton"
      :pageType="pageType"
      :step="step"
      :stepOneReady="firstStepCompleted"
      :stepTwoReady="secondStepCompleted"
      :hasError="wcSendError.active"
      :errorMessage="wcSendError.message"
      :isSending="isSending"
      :proceedError="proceedError"
      :proceedErrorMsg="proceedErrorMsg"
      @next="scrollToNextStep()"
      @finish="sendToWooCommerce()"
    />

    <Modal
      v-if="modalIsOpen"
      :partner="modalPartner"
      @choosePartner="choosePartner($event)"
      @closeModal="closeModal()"
      slot="modal"
    />

  </div>
</template>

<script>
import { Header, Footer, Modal } from './components'
import { Step1, Step2 } from './views'

import { api as wc } from './utils/woocommerce'

export default {
  name: 'CheckoutWizard',
  components: {
    Header,
    Footer,
    Step1,
    Step2,
    Modal,
  },
  props: {
    product: {
      type: String,
      default: '',
      required: true,
    },
    partners: {
      type: String,
      default: '',
      required: true,
    },
    pageType: {
      type: String,
      default: '',
      required: true,
    },
    thankPage: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      showNextStepButton: false,
      firstStepCompleted: false,
      secondStepCompleted: false,
      modalIsOpen: false,
      modalPartner: {},
      selectedPartner: {},
      formattedPartners: [],
      formattedProduct: [],
      persoonsgegevens: {
        voornaam: '',
        achternaam: '',
        bedrijfsmail: '',
        telefoonnummer: '',
        bedrijf: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      factuurgegevens: {
        otherAddress: false,
        tav: '',
        factuurmail: '',
        adres: '',
        plaats: '',
        postcode: ''
      },
      overig: {
        opmerking: '',
        acceptsTerms: false,
      },
      isSending: false,
      wcSendError: {
        active: false,
        message: 'Er ging iets fout bij het versturen van je gegevens. Probeer het a.u.b. opnieuw.'
      },
      proceedError: false,
      proceedErrorMsg: ''
    }
  },
  methods: {
    isViewingPartners($event) {
      this.showNextStepButton = $event;
      const container = document.querySelector('#__teachdigital');
      const wizard = document.querySelector(' #wizard ');



      function addViewPortClasses() {
        const elTop = wizard.getBoundingClientRect().top;
        let elBottom = elTop + wizard.offsetHeight + window.scrollY + 100;
        const viewportBottom = window.innerHeight + window.scrollY;
        if (elBottom < viewportBottom) {
          container.classList.add('wizardInViewport');
        } else {
          if (container.classList.contains('wizardInViewport')) {
            container.classList.remove('wizardInViewport');
          }
        }
      }

      addViewPortClasses();

      if ($event === true) {
        document.addEventListener('scroll', addViewPortClasses, true);
      } else {
        document.removeEventListener('scroll', addViewPortClasses, true);
      }
    },
    findGetParameter(parameterName) {
      var result = null,
        tmp = [];
      var items = location.search.substr(1).split("&");
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
    },
    preSelectPartners() {
      if (this.findGetParameter('partner')) {
        console.log(this.findGetParameter('partner'));

        let partners = [...this.formattedPartners];
        partners.forEach( (partner) => {
          if (partner.post_title === this.findGetParameter('partner')) {
            this.selectedPartner.ID = partner.ID
            this.firstStepCompleted = true;
          }
        })
      }
    },
    openModal($event) {
      this.modalIsOpen = true;
      this.modalPartner = $event;
      this.$nextTick(() => {
        let modal = document.querySelector('#partnerModal');
        modal.addEventListener('click', (e) => {
          if (e.target.id === 'partnerModal') {
            this.closeModal();
          }
        })
      })
    },
    closeModal() {
      let body = document.body;
      body.classList.remove('overflow-hidden', 'h-screen', 'lg:overflow-visible');
      this.modalIsOpen = false;
      this.modalPartner = {};
    },
    formatProps() {

      if (this.partners !== '') {
        let partners = JSON.parse(this.partners);
        this.formattedPartners = partners;
      }

      // if (this.product !== '') {
      //   let product = JSON.parse(this.product);
      //   this.formattedProduct = product;
      // }

    },
    changeStep(event) {
      this.step = event;
    },
    scrollToNextStep() {
      if (this.selectedPartner && Object.keys(this.selectedPartner).length === 0 && this.selectedPartner.constructor === Object) {
        this.proceedError = true;
        this.proceedErrorMsg = 'Selecteer eerst een aanbieder uit de buurt om door te gaan.'
      } else {
        this.step = 2;
        this.$scrollTo('#wizard', 200, {
          easing: "ease",
          offset: -30
        });
      }

    },
    choosePartner(event) {
      this.proceedError = false;
      this.proceedErrorMsg = '';
      this.firstStepCompleted = true;
      this.selectedPartner = event;
      this.closeModal()
      this.step = 2;
      this.$scrollTo('#wizard', 200, {
        easing: "ease",
        offset: 0
      });
    },
    async sendToWooCommerce() {

      if (this.$refs.step2.checkInputs() === false) {
        this.proceedError = true;
        this.proceedErrorMsg = 'Niet alle verplichte velden lijken ingevuld. Probeer deze in te vullen en dan nog eens te versturen';

        return false;
        
      } else {
        this.proceedError = false;
        this.proceedErrorMsg = '';
        this.isSending = true;
        let payment_method = '';
        let payment_method_title = ''
        let status = '';
        if (this.pageType === 'inschrijven') {
          payment_method_title = 'Inschrijven'
          payment_method = 'td-entry';
          status = 'entry-not-paid';
        } else if (this.pageType === 'offerte-aanvragen') {
          payment_method_title = 'Offerte aanvraag'
          payment_method = 'td-quote';
          status = 'quote-request-new';
        }

        let order = {
          payment_method: payment_method,
          payment_method_title: payment_method_title,
          set_paid: false,
          status: status,
          billing: {
            first_name: this.persoonsgegevens.voornaam,
            last_name: this.persoonsgegevens.achternaam,
            address_1: this.factuurgegevens.adres,
            address_2: "",
            city: this.factuurgegevens.plaats,
            state: "",
            postcode: this.factuurgegevens.postcode,
            country: "Nederland",
            email: this.persoonsgegevens.bedrijfsmail,
            phone: this.persoonsgegevens.telefoonnummer,
            company: this.persoonsgegevens.bedrijf
          },
          shipping: {
            first_name: this.persoonsgegevens.voornaam,
            last_name: this.persoonsgegevens.achternaam,
            address_1: this.factuurgegevens.adres,
            address_2: "",
            city: this.factuurgegevens.plaats,
            state: "",
            postcode: this.factuurgegevens.postcode,
            country: "Nederland",
          },
          line_items: [
            {
              product_id: this.product,
              quantity: 1
            },
          ],
          meta_data: [
            {
              id: 1,
              key: 'Partner',
              value: this.selectedPartner.acf.bedrijfsgegevens.bedrijfsnaam,
            },
            {
              id: 2,
              key: 'Opmerking',
              value: this.overig.opmerking,
            },
            {
              id: 3,
              key: 'Soort-aanvraag',
              value: this.pageType,
            }
          ]
        }

        wc.post('orders', order)
          .then((response) => {
            console.log("Response Status:", response.status);
            console.log("Response Headers:", response.headers);
            console.log("Response Data:", response.data);
            console.log("Total of pages:", response.headers['x-wp-totalpages']);
            console.log("Total of items:", response.headers['x-wp-total']);

            setTimeout(() => {
              window.location.href = this.thankPage;
            }, 500)

          })
          .catch((error) => {
            // Invalid request, for 4xx and 5xx statuses
            console.log("Response Status:", error.response.status);
            console.log("Response Headers:", error.response.headers);
            console.log("Response Data:", error.response.data);

            this.wcSendError.active = true;
          })
          .finally(() => {
            this.isSending = false;
            return;
          });
      }
    }
  },
  mounted() {
    this.formatProps();
    this.preSelectPartners();
  }
}
</script>
